import { CludoSearchResults } from 'ui/components';

export const CludoSearchResultsFeature: React.FC<Umbraco.CludoSearchResults> = ({ content }) => {
	return <CludoSearchResults {...content.properties} />;
};
